import { render } from "./swiper-cards.vue?vue&type=template&id=e569434e&scoped=true"
import script from "./swiper-cards.vue?vue&type=script&lang=js"
export * from "./swiper-cards.vue?vue&type=script&lang=js"

import "./swiper-cards.vue?vue&type=style&index=0&id=e569434e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e569434e"

export default script